export const TOGGLE_BODY_SCROLL = "TOGGLE_BODY_SCROLL";
export const TOGGLE_LOADING = "TOGGLE_LOADING";
